<template>
<div class="eta">
  <div class="eta__mask eta__mask-full" v-bind:style="rotateDeg">
    <div class="eta__fill" v-bind:style="rotateDeg"></div>
  </div>
  <div class="eta__mask eta__mask-half">
    <div class="eta__fill" v-bind:style="rotateDeg"></div>
    <div class="eta__fill eta__fill-fix" v-bind:style="rotateDegFix"></div>
  </div>
  <div class="eta__data">
    <span class="text-gray-light">ETA</span>
    <span class="text-color-gray-dark-2 text-center">{{ sliderValue || 0 }}H</span>
  </div>
</div>
</template>


<script>

export default {
  name: 'eta',

  props: {
    sliderValue: {
      type: Number,
      required: true
    },
    sliderPercentage: {
      type: Number,
      required: true
    }
  },

  data () {

    return {   
      rotateStyle: {transform: 'rotate(0deg)'},
      fixStyle: {transform: 'rotate(0deg)'}
    }
  },

  computed: {
    rotateDeg () {
      let deg = Math.abs(Math.floor((1 - this.sliderPercentage) * 180))
      this.rotateStyle.transform = `rotate(${deg}deg)`
      return this.rotateStyle
    },
    rotateDegFix () {
      let deg = Math.abs(Math.floor((1 - this.sliderPercentage) * 180))
      this.fixStyle.transform = `rotate(${deg * 2}deg)`
      return this.fixStyle
    }
  }
}
</script>


// WEBPACK FOOTER //
// Eta.vue?221d1e53